import { LOCALES } from 'config/constants'
import { isSame } from 'lib/utils'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { IAuthState, selectLng } from 'store/auth'

const CONTENT_ONLY_KEY = 'content-only'

// Липкий content-only (webview приложения): первая загрузка с
// ?content-only=1 запоминает режим на сессию webview. Setter на уровне
// модуля — срабатывает до React, независимо от судьбы гидрации.
if (typeof window !== 'undefined') {
  try {
    if (
      new URLSearchParams(window.location.search).get(
        CONTENT_ONLY_KEY
      ) === '1'
    )
      window.sessionStorage.setItem(CONTENT_ONLY_KEY, '1')
  } catch {
    // sessionStorage недоступен — работаем только от query
  }
}

// Reader липкого флага. ВАЖНО: в рендере использовать только для
// АТРИБУТОВ (href и т.п.) — структурные ветвления по нему в рендере
// ломают гидрацию (в Layout чтение идёт через useEffect).
export let isContentOnlyStored = () => {
  if (typeof window === 'undefined') return false
  try {
    return window.sessionStorage.getItem(CONTENT_ONLY_KEY) === '1'
  } catch {
    return false
  }
}

let useSlug = <T extends string | string[] | undefined>() => {
  let router = useRouter()
  let query = router.query as Record<string, string>
  let slug = router.query['slug'] as T
  let lng = useSelector(selectLng)

  return {
    router,
    query,
    slug,
    queryLng: (lng ?? LOCALES.includes(router.locale ?? '')
      ? router.locale
      : 'ru') as NonNullable<IAuthState['lng']>,
    showOnlyContent: isSame(query['content-only'], '1'),
  }
}

export default useSlug
